import { Switch } from '@mui/material';
import React      from 'react';
import styled     from 'styled-components';

export const IOSSwitch = styled(Switch)(({ theme }: any) => ({
  width   : '42px !important',
  height  : '26px !important',
  padding : '0 !important',
  margin  : `${theme?.spacing?.(1) || 8}px !important`,

  '& .MuiSwitch-switchBase': {
    padding         : 1,
    '&.Mui-checked' : {
      transform              : 'translateX(16px)',
      color                  : theme?.palette?.common?.white || '#fff',
      '& + .MuiSwitch-track' : {
        backgroundColor : '#547cd3',
        opacity         : 1,
        border          : 'none',
      },
      '& .MuiSwitch-thumb': {
        border: '3px solid #547cd3',
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color  : '#547cd3',
      border : '6px solid #fff',
    },
  },

  '& .MuiSwitch-thumb': {
    width     : 24,
    height    : 24,
    border    : `4px solid ${ theme?.palette?.grey?.[400] || '#bdbdbd' }`,
    boxShadow : 'unset',
  },

  '& .MuiSwitch-track': {
    borderRadius    : 26 / 2,
    border          : `4px solid ${ theme?.palette?.grey?.[400] || '#bdbdbd' }`,
    backgroundColor : theme?.palette?.grey?.[50] || '#fafafa',
    opacity         : 1,
  },
}));
